// 设置要过滤的函数parseTime、formatTime
export { parseTime, formatTime } from '@/utils'

function pluralize(time, label) {
  if (time === 1) {
    return time + label
  }
  return time + label + 's'
}

export function timeAgo(time) {
  const between = Date.now() / 1000 - Number(time)
  if (between < 3600) {
    return pluralize(~~(between / 60), ' minute')
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), ' hour')
  } else {
    return pluralize(~~(between / 86400), ' day')
  }
}

/* 数字 格式化*/
export function numberFormatter(num, digits) {
  const si = [
    { value: 1E18, symbol: 'E' },
    { value: 1E15, symbol: 'P' },
    { value: 1E12, symbol: 'T' },
    { value: 1E9, symbol: 'G' },
    { value: 1E6, symbol: 'M' },
    { value: 1E3, symbol: 'k' }
  ]
  for (let i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (num / si[i].value + 0.1).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol
    }
  }
  return num.toString()
}

export function toThousandFilter(num) {
  return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}
// 保留两位小数，自动补充零
export function returnFloat(value){
  var value = Math.round(parseFloat(value)*100)/100;
  var xsd = value.toString().split(".");
  if( xsd.length == 1 ){
    value=value.toString() + ".00";
    return value;
  }
  if( xsd.length>1 ){
    if(xsd[1].length<2){
      value=value.toString() + "0";
    }
    return value;
  }
 }
 // 下载来源
export function laiyuanqState(val){
  let key = String(val)
  switch (key) {
        case '0':
            return '公司官网'
            break      
        case '1':
            return '360'
            break
        case '2':
            return '应用宝'
            break
        case '3':
            return '百度'
            break
        case '4':
            return '豌豆荚'
            break          
        case '5':
            return '华为'
            break 
        case '6':
            return '小米'
            break
        case '7':
            return '魅族'
            break     
        case '8':
            return '三星'
            break 
        case '9':
            return 'Oppo'
            break  
        case '10':
            return 'Vivo'
            break
        case '11':
            return '安智'
            break 
        case '12':
            return '木蚂蚁'
            break
        case '13':
            return '联想'
            break   
        case '14':
              return 'APP Store Ios'
              break 
        case '15':
                return 'web端'
                break                                      
        case 'undefined':
            return '未知'
            break
        default:
            break;
    }
}
// 状态过滤器
export function status(val) {
  switch (val) {
        case '0':
            return '状态0'
            break
        case '1':
            return '状态2'
            break  
        default:
            break;
    }
}


// WEBPACK FOOTER //
// ./src/filters/index.js